import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {TranslateService} from '@ngx-translate/core';
import {SurveyService} from '../../services/surveys.service';
import {AlertService} from '../../services/general/alert.service';
import {Router} from '@angular/router';
import {ToastService} from '../../services/general/toast.service';

@Component({
  selector: 'app-modal-survey-revision-preview',
  templateUrl: './modal-survey-revision-preview.component.html',
  styleUrls: ['./modal-survey-revision-preview.component.scss'],
  standalone: false
})
export class ModalSurveyRevisionPreviewComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<ModalSurveyRevisionPreviewComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public translateService: TranslateService,
    public surveyService: SurveyService,
    public alertService: AlertService,
    public router: Router,
    public toast: ToastService
  ) {
  }

  ngOnInit(): void {
  }

  close(): void {
    this.dialogRef.close();
  }

  confirmRevision() {
    const revision = () => {
      this.surveyService.createSurveyRevision(this.data?.survey_id).subscribe({
        next: (data: any) => {
          this.close();
          this.toast.success(
            this.translateService.instant('generic.success'),
            this.translateService.instant('modals.modal-survey-details.survey-created-successfully')
          );
          this.router.navigate(['/']).then(() => {
            this.router.navigate(['/surveys', data?.survey?.id]);
          });
        },
        error: err => {
          if (err.status === 422 || err.status === 400) {
            this.alertService.showAlert(
              this.translateService.instant('generic.error'),
              err.error?.message || err?.error?.errors[0],
              'error'
            );
          }
        }
      });
    };

    if (this.data.survey_is_closed) {
      revision();
    } else {
      this.alertService.showQuestionWithError(
        this.translateService.instant('modals.modal-survey-revision-preview.error-on-revision-survey'),
        this.translateService.instant('modals.modal-survey-revision-preview.survey-has-to-close'),
        () => {
          const model = {
            status: 'CLOSED'
          };
          this.surveyService.changeSurveyStatus(this.data?.survey_id, model, () => {
            revision();
          });
        }
      );
    }
  }
}
